module.exports = __webpack_public_path__ + "img/77.bf7a074b.jpg";